import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { AppBase } from './app-base';

export const BASE_URL_REPORTS = environment.BASE_URL_REPORTS;
export const BASE_URL_CRUD = environment.BASE_URL_CRUD;
export const BASE_URL_BULK_UPLOAD = environment.BASE_URL_BULK_UPLOAD;
export const BASE_URL_ACCOUNTING_ACCOUNT = environment.BASE_URL_ACCOUNTING_ACCOUNT;
export const BASE_URL_SSO = environment.BASE_URL_SSO;
export const REALM = environment.REALM;
export const REALM_K3REM = environment.REALM_K3REM;
export const BASE_URL_K3REM = environment.BASE_URL_K3REM;
export const BASE_URL_API_K3REM = environment.BASE_URL_API_K3REM;
export const BASE_URL_ALERT = environment.BASE_URL_ALERT;
export const BASE_URL_MESSAGE = environment.BASE_URL_MESSAGE;
export const KIUNGO_DOMAIN = environment.KIUNGO_DOMAIN;
export const BASE_URL_SOCKET_IO = environment.BASE_URL_SOCKET_IO;
export const KEY_FROALA_KASTOR = environment.KEY_FROALA_KASTOR;
export const KEY_FROALA_KIUNGO = environment.KEY_FROALA_KIUNGO;
export const LOGO_KASTOR = environment.LOGO_KASTOR;
export const LOGO_KIUNGO = environment.LOGO_KIUNGO;
export const LOGO_COMUNIDAD_KIUNGO = environment.LOGO_COMUNIDAD_KIUNGO;
export const LOGO_COMUNIDAD_KASTOR = environment.LOGO_COMUNIDAD_KASTOR;
export const BASE_URL_PAYMENT_KASTOR = environment.BASE_URL_PAYMENT_KASTOR;
export const BASE_URL_PAYMENT_KIUNGO = environment.BASE_URL_PAYMENT_KIUNGO;
export const BASE_URL_TRANSLATION = environment.BASE_URL_TRANSLATION;
export const S3_BUCKET_URL = `${environment.S3_BASE_URL}${environment.S3_BUCKET}\/`;
export const BASE_URL_KHIPU = environment.BASE_URL_KHIPU;
export const HELP_CENTER_URL = environment.HELP_CENTER_URL;
export const BASE_URL_MERCADOPAGO = environment.BASE_URL_MERCADOPAGO;

@Injectable()
export class AppService extends AppBase {

  // variables
  public endpoint = '/';

  constructor(private http: HttpClient) {
    super();
  }

  public generateHeaders(): HttpHeaders {
    // Establecemos cabeceras
    const token = this.getCurrentUserToken();

    let headers = null;
    if (token) {
      headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token });
    } else {
      headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    return headers;
  }

  public generateHeadersText(): HttpHeaders {
    // Establecemos cabeceras
    const token = this.getCurrentUserToken();

    let headers = null;
    if (token) {
      headers = new HttpHeaders({ 'Content-Type': 'text/html', 'Authorization': 'Bearer ' + token });
    } else {
      headers = new HttpHeaders({ 'Content-Type': 'text/html' });
    }
    return headers;
  }

  get(url: any, type: any = 'json'): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.get(url, { headers: headers, responseType: type });
  }

  getNormal(url: any, type: any = 'json'): Observable<any> {
    return this.http.get(url);
  }

  post(url: any, object: any, type: any = 'json'): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.post(url, object, { headers: headers, responseType: type });
  }

  patch(url, data: any, accessToken: string = null): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.patch(url, data, { headers: headers });
  }

  upload(url: any, formData: FormData): Observable<any> {
    const token = this.getCurrentUserToken();
    const headers = new HttpHeaders({ 'Accept': 'application/json', 'Authorization': 'Bearer ' + token });
    return this.http.post(url, formData, { headers: headers });
  }


  postLogin(url: any, object: any): Observable<any> {
    return this.http.post(url, object);
  }

  put(url: any, object: any, type: any = 'json'): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.put(url, object, { headers: headers, responseType: type });
  }

  delete(url: any, type: any = 'json', object: any = null): Observable<any> {
    const headers = this.generateHeaders();
    return !object
    ? this.http.delete(url, { headers: headers, responseType: type })
    : this.http.request('delete', url, { headers: headers, responseType: type, body: object });
  }

  generate(url: any, object: any): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.post(url, object, { headers: headers, responseType: 'blob' });
  }

  generateJSON(url: any, object: any): Observable<any> {
    const headers = this.generateHeaders();
    return this.http.post(url, object, { headers: headers, responseType: 'json' });
  }

  download(url: any): Observable<Blob> {
    const headers = this.generateHeaders();
    return this.http.get(url, { headers: headers, responseType: 'blob' });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts